// src/pages/UserEdit.js
import React, { useEffect, useState } from 'react';
import { Container, Form, Button, Card, Accordion } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchUserById, updateUser, fetchPermissions } from '../redux/actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import PermissionsForm from './components/users/CreateUserPermissions';
import CreateUserRoleSelect from './components/users/CreateUserRoleSelect';

function UserEdit() {
  const { userId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  // Get the selected user from Redux
  const userFromStore = useSelector((state) => state.user.selectedUser);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('');
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [availablePermissions, setAvailablePermissions] = useState([]);

  useEffect(() => {
    if (userId) {
      dispatch(fetchUserById(userId));
    }
  }, [dispatch, userId]);

  // Prefill form fields if editing an existing user
  useEffect(() => {
    if (userFromStore) {
      setName(userFromStore.name || '');
      setEmail(userFromStore.email || '');
      setRole(userFromStore.role || '');
      setSelectedPermissions(userFromStore.permissions || []);
    }
  }, [userFromStore]);

  // Fetch available permissions from the API
  useEffect(() => {
    dispatch(fetchPermissions())
      .then((data) => {
        setAvailablePermissions(data);
      })
      .catch((error) => {
        console.error('Error fetching permissions:', error);
      });
  }, [dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Payload for update user:", userId, name, email, role, selectedPermissions);
    dispatch(updateUser({ id: userId, name, email, role, permissions: selectedPermissions }));
    navigate('/users');
  };

  return (
    <Container className="mt-4">
      <Card>
        <Card.Body>
          <Card.Title>Edit User</Card.Title>
          <Accordion className="mb-2">
            <Accordion.Item eventKey="0">
              <Accordion.Header>Help</Accordion.Header>
              <Accordion.Body>
                <h6>User Information</h6>
                <p>- Please enter full name or company name in the Name field.</p>
                <p>- Enter a valid email address.</p>
                <p>- Select the appropriate role desired:</p>
                <ul>
                  <li>Admin - Full access to all features.</li>
                  <li>User - Can only access apps, no admin features.</li>
                </ul>
                <p>- Select permissions for the user:</p>
                <ul>
                  <li>Shipping - Access to shipping app.</li>
                  <li>User Creation - Can create new users.</li>
                  <li>Logs - Can view logs.</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formName" className="mb-2">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="formEmail" className="mb-2">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
            <CreateUserRoleSelect role={role} setRole={setRole} />
            <PermissionsForm 
              availablePermissions={availablePermissions} 
              selectedPermissions={selectedPermissions}
              setSelectedPermissions={setSelectedPermissions} 
            />
            <Button variant="primary" type="submit" className="mt-3 w-100">
              Save Changes
            </Button>
          </Form>
          <Button variant="warning" onClick={() => navigate('/password-change')} className="mt-2 w-100">
            Change Password
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default UserEdit;
